import React from 'react'
import s from './Venues.module.scss'
import { useTranslation } from 'react-i18next';
const VenuesCategories = ({ item, setSelectedMenuCategory, isSelected }) => {
  const {t} = useTranslation() as any;
  
    return (
        <div
            className={s.subcategories_categories}
            style={{
                backgroundImage: `url(${item?.image})`,
                backgroundColor: isSelected ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
                backgroundBlendMode: isSelected ? 'darken' : 'normal',
            }}
            onClick={() => setSelectedMenuCategory(isSelected ? null : item?.id)}
        >
            <div>{t(item?.name)}</div>
        </div>
    )
}

export default VenuesCategories